module.exports = __webpack_public_path__ + "img/doha-1.1e67c559.jpg";